import { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Label } from "../design/fieldset";
import { Button } from "../design/button";
import { EditableFile } from "../models/EditableFile";
import EditableFileListItem from "./EditableFileListItem";
import { Text } from "../design/text";

interface Props {
  files: EditableFile[];
  setFiles: React.Dispatch<React.SetStateAction<EditableFile[]>>;
}

const Dropzone: React.FC<Props> = ({ files, setFiles }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      const newFiles = acceptedFiles.map((file) => ({
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      }));
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    },
  });

  // Cleanup previews on unmount
  useEffect(() => {
    return () => {
      files.forEach(
        (file) => file.preview && URL.revokeObjectURL(file.preview),
      );
    };
  }, [files]);

  return (
    <div className="space-y-6">
      {/* Dropzone Area */}
      <div
        {...getRootProps()}
        className={`p-6 text-center border-2 border-dashed rounded-lg cursor-pointer ${
          isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"
        }`}
      >
        <input {...getInputProps()} />
        <Text>
          {isDragActive
            ? "Drop files here..."
            : "Drag & drop files here, or click to select files"}
        </Text>
      </div>
    </div>
  );
};

export default Dropzone;
